/**
 * Framework-free navigation model. Nothing here may import Angular, RxJS or `environment` —
 * this folder is copied verbatim into `@federation/shared-navigation` when the React shell
 * goes live, so every input arrives as an argument (see ResolveNavInput / NavCtx).
 */
export * from './types';
export * from './routes';
export * from './presets';
export * from './config';
export * from './resolve';
export * from './landing';
